import { getRequest } from '../common/http/lib';
import {
  FILE_REQUEST_TAXONOMY_OPTIONS_API_URL,
  FILE_REQUEST_TAXONOMY_OPTIONS_PUBLIC_API_URL,
} from '../constants';

type GetTaxonomyOptionsParams = {
  isSameEnterprise: boolean;
  fileRequestId: string;
  scope: string;
  fieldKey: string;
  searchInput: string;
  templateKey: string;
};

type GetTaxonomyOptionsResponse = {
  options: Array<string>;
};

const getTaxonomyOptions = async ({
  isSameEnterprise,
  fileRequestId,
  scope,
  fieldKey,
  searchInput,
  templateKey,
}: GetTaxonomyOptionsParams): Promise<GetTaxonomyOptionsResponse> => {
  const optionsApiUrl = !isSameEnterprise
    ? `${FILE_REQUEST_TAXONOMY_OPTIONS_PUBLIC_API_URL}/${fileRequestId}/${scope}/${templateKey}/${fieldKey}`
    : `${FILE_REQUEST_TAXONOMY_OPTIONS_API_URL}/${scope}/${templateKey}/${fieldKey}`;

  return getRequest(optionsApiUrl, {
    ...(searchInput && { params: { query_text: searchInput } }),
  }).then(response => {
    const {
      data: { entries },
    } = response;
    return {
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
      options: entries.map(option => ({
        displayValue: option.display_name,
        value: option.id,
      })),
    };
  });
};

const TaxonomyFetcherAPI = {
  getTaxonomyOptions,
} as const;
export default TaxonomyFetcherAPI;
